// src/App.js
import React, { useState } from 'react';
import './App.css';
import MapComponent from './MapComponent';
import IzakayaList from './IzakayaList';

function App() {
  const [selectedIzakayaId, setSelectedIzakayaId] = useState(null);

  // リストのアイテムがクリックされたときに呼ばれる関数
  const handleIzakayaClick = (id) => {
    setSelectedIzakayaId(id);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>長野市で長野県を感じる居酒屋呑みガイド</h1>
        <p>長野を感じる居酒屋を見つけましょう！</p>
      </header>
      <main>
        <div className="map-and-list">
          {/* 選択された居酒屋のIDをMapComponentに渡す */}
          <MapComponent selectedIzakayaId={selectedIzakayaId} />
          {/* handleIzakayaClickをリストに渡す */}
          <IzakayaList onIzakayaClick={handleIzakayaClick} />
        </div>
      </main>
      <footer>
        <p>© 2024 長野市で長野県を感じる居酒屋呑みガイド</p>
      </footer>
    </div>
  );
}

export default App;
